import API from '../../../API/api';
import Cart from '../../stores/models/cart';
import BillingAddress from '../../stores/models/billing_address';
import FittingOption from '../../stores/models/fitting_option';
import FitterService from '../../stores/models/fitter_service';
/**
 * @param cart
 * @param fittingOptions
 * @param billingAddress
 * @returns {*}
 */
function mixedStocksPlaceOrderRequest(cart, fittingOptions, fittingServices, billingAddress) {
    'use strict';
    if (!(cart instanceof Cart) || !(billingAddress instanceof BillingAddress)) {
        console.warn('Invalid cart data');
        return;
    }

    let payload = {
        items: [],
        services: [],
        billingAddress: {
            firstName: billingAddress.firstName,
            lastName: billingAddress.lastName,
            company: billingAddress.company,
            email: billingAddress.email,
            telephone: billingAddress.telephone,
            marketingConsent: billingAddress.marketingConsent,
        },
        shippingAddress: {
            addressType: cart.shippingAddress.addressType,
            postcode: cart.shippingAddress.postcode,
        }
    };

    //items
    cart.items.map((item) => {
        let items = {
            productCode: item.productCode,
            stockType: item.stockType,
            itemStocks: []
        };

        item.itemStocks.map((itemStock) => {
            items.itemStocks.push({
                supplierStock: {
                    idSupplierStock: itemStock.supplierStock.idSupplierStock,
                },
                qty: itemStock.qty,
            });
        });

        payload.items.push(items);
    });

    const isFittingStation = (null !== cart.shippingAddress.fsId && true === cart.shippingAddress.isFittingStationAddress);
    //services
    if (isFittingStation) {
        const selectedFsId = cart.shippingAddress.fsId;
        fittingOptions.map((fittingOption) => {
            if (fittingOption instanceof FittingOption && selectedFsId === fittingOption.fs.fsId) {
                fittingOption.services.map((service) => {
                    if (service instanceof FitterService
                        && fittingServices.indexOf(service.type) >= 0) {
                        payload.services.push({
                            type: service.type,
                            productUnitQty: service.productUnitQty
                        });
                    }
                });
            }
        });
    }

    //shippingAddress
    if (isFittingStation) {
        payload.shippingAddress.fsId = cart.shippingAddress.fsId;
    } else {
        payload.shippingAddress = cart.shippingAddress;
    }

    const data = JSON.stringify(payload);
    return API.POST({
        apiPath: '/api/v2/orders/mixedstock/',
        data: data,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8'
    })
    .catch(response => {})
    .done(response => {});
}

export default mixedStocksPlaceOrderRequest;